import React, { ReactElement } from 'react';
import dynamic from 'next/dynamic';
import classNames from 'classnames/bind';
import RootLayout from 'layouts/RootLayout';
import { LeadFormParameters } from 'components/LeadForm/LeadForm.data';
import styles from 'styles/pages/DigitalTools/CargoesFlow/CargoesFlow.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = dynamic(() => import('sections/DigitalTools/CargoesFlow/components/SectionHeader'));
const SectionAbout = dynamic(() => import('sections/DigitalTools/CargoesFlow/components/SectionAbout'));
const SectionAdvantages = dynamic(() => import('sections/DigitalTools/CargoesFlow/components/SectionAdvantages'));
const SectionVisibility = dynamic(() => import('sections/DigitalTools/CargoesFlow/components/SectionVisibility'));
const SectionFeatures = dynamic(() => import('sections/DigitalTools/CargoesFlow/components/SectionFeatures'));
const SectionScheme = dynamic(() => import('sections/DigitalTools/CargoesFlow/components/SectionScheme'));
const SectionSaas = dynamic(() => import('sections/DigitalTools/CargoesFlow/components/SectionSaas'));
const SectionForm = dynamic(() => import('sections/DigitalTools/CargoesFlow/components/SectionForm'));

type CargoesFlowProps = {
  pageTitle?: string;
  formUrl?: string;
  leadSubtype?: string;
};

export default function CargoesFlow({ pageTitle, formUrl, leadSubtype }: CargoesFlowProps) {
  return (
    <main className={cn('cargoes-flow')}>
      <SectionHeader />
      <SectionAbout />
      <SectionAdvantages />
      <SectionVisibility />
      <SectionFeatures />
      <SectionScheme />
      <SectionSaas />
      <SectionForm
        pageTitle={pageTitle}
        formUrl={formUrl}
        leadSubtype={leadSubtype}
      />
    </main>
  );
}

export const getStaticProps = async () => {
  // 'FormParameters' - parameters, passed to 'Form' component in 'SectionForm' on all Benefits pages as additional data for CRM: 
  const FormParameters = {
    pageTitle: LeadFormParameters.cargoesFlow.pageTitle,
    formUrl: LeadFormParameters.cargoesFlow.formUrl,
    leadSubtype: LeadFormParameters.cargoesFlow.leadSubtype,
  };

  return {
    props: {
      title: 'Cargoes Flow | Container Tracking | DF Alliance',
      description: 'Enhance your freight management with DF Alliance\'s cargo flow. Monitor, optimize, & control your cargo movements in real-time for efficient logistics.',
      path: '/digital-tools/cargoes-flow',
      ...FormParameters,
    },
  };
};

CargoesFlow.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
